import { useState, useEffect } from 'react';
import postsAPI from '../api/posts.api';

export const usePosts = (page = 1, limit = 12, category = null) => {
  const [posts, setPosts] = useState([]);
  const [pagination, setPagination] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        setLoading(true);
        setError(null);
        const data = await postsAPI.getPosts(page, limit, category);
        setPosts(data.posts);
        setPagination(data.pagination);
      } catch (err) {
        setError(err.response?.data?.error || 'Failed to fetch posts');
        setPosts([]);
      } finally {
        setLoading(false);
      }
    };

    fetchPosts();
  }, [page, limit, category]);

  return { posts, pagination, loading, error };
};

export const usePost = (slug) => {
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!slug) return;

    const fetchPost = async () => {
      try {
        setLoading(true);
        setError(null);
        const data = await postsAPI.getPostBySlug(slug);
        setPost(data);
      } catch (err) {
        setError(err.response?.data?.error || 'Failed to fetch post');
        setPost(null);
      } finally {
        setLoading(false);
      }
    };

    fetchPost();
  }, [slug]);

  return { post, loading, error };
};
